import Settings from '../service/settings'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    configsetting(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Settings.configsetting(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getsetting(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Settings.getsetting(payload), {
        type: 'list',
        success,
        fail
      })
    },
    configgiftcard(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Settings.configgiftcard(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getgiftcardconfig(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Settings.getgiftcardconfig(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
